<script>
import Transfer from 'element-ui/lib/transfer';

export default Transfer;
</script>

<style lang="scss">
@import '~@/stylesheets/element-theme/transfer.css';

.el-transfer {
  .el-checkbox-group.el-transfer-panel__list {
    display: block;
  }

  .el-checkbox {
    @include rtl() {
      margin-right: 0;
      padding-left: 0;
      padding-right: 15px;
    }

    &__label {
      @include rtl() {
        padding-left: 0;
        padding-right: 24px;
      }
    }
  }

  &__buttons {
    .el-button {
      @include rtl() {
        transform: rotate(180deg);
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  &-panel &-panel__header {
    .el-checkbox {
      // stylelint-disable-next-line selector-max-compound-selectors
      &__label span {
        @include rtl() {
          right: auto;
          left: 15px;
        }
      }
    }
  }
}
</style>
